export const books = [
  {
    title: 'The Middle of Things',
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: 'Viner',
    question: 'Detective',
    numChapters: 29,
    results: {
      1: 23,
      2: 41,
      3: 28,
      4: 41,
      5: 35,
      6: 25,
      7: 17,
      8: 26,
      9: 11,
      10: 26,
      11: 10,
      12: 35,
      13: 31,
      14: 29,
      15: 34,
      16: 30,
      17: 10,
      18: 12,
      19: 5,
      20: 12,
      21: 10,
      22: 12,
      23: 3,
      24: 12,
      25: 45,
      26: 9,
      27: 36,
      28: 44,
      29: 18
    }
  },
  {
    title: 'The Middle of Things',
    author: 'J.S. Fletcher',
    queryType: 'nearby',
    query: 'Viner',
    question: 'Nearby Words',
    numChapters: 29,
    before: [
      ['the', 8],
      ['he', 6],
      ['and', 19]
    ],
    after: [
      ['had', 13],
      ['a', 14],
      ['to', 12]
    ]
  },
  {
    title: 'The Middle of Things',
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: 'Cortelyon',
    question: 'Perpetrator',
    numChapters: 29,
    results: {
      1: 0,
      2: 4,
      3: 2,
      4: 0,
      5: 0,
      6: 0,
      7: 0,
      8: 0,
      9: 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 0,
      16: 0,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 0,
      22: 0,
      23: 0,
      24: 0,
      25: 0,
      26: 0,
      27: 0,
      28: 16,
      29: 8
    }
  },
  {
    title: 'The Middle of Things',
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: 'murder',
    question: 'Crime',
    numChapters: 29,
    results: {
      1: 3,
      2: 9,
      3: 7,
      4: 7,
      5: 8,
      6: 7,
      7: 5,
      8: 2,
      9: 1,
      10: 2,
      11: 8,
      12: 6,
      13: 7,
      14: 3,
      15: 7,
      16: 7,
      17: 7,
      18: 5,
      19: 3,
      20: 1,
      21: 4,
      22: 7,
      23: 4,
      24: 3,
      25: 0,
      26: 0,
      27: 0,
      28: 6,
      29: 2
    }
  },
  {
    title: 'The Middle of Things',
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: 'Penkridge',
    question: 'Other Suspects',
    numChapters: 29,
    results: {
      1: 18,
      2: 2,
      3: 11,
      4: 0,
      5: 0,
      6: 7,
      7: 0,
      8: 6,
      9: 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 2,
      16: 0,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 0,
      22: 1,
      23: 0,
      24: 14,
      25: 9,
      26: 0,
      27: 0,
      28: 9,
      29: 4
    }
  },
  {
    title: 'Scarhaven Keep',
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: 'Richard Copplestone|Copplestone',
    question: 'Detective',
    numChapters: 31,
    results: {
      1: 14,
      2: 18,
      3: 24,
      4: 28,
      5: 23,
      6: 30,
      7: 35,
      8: 33,
      9: 24,
      10: 31,
      11: 23,
      12: 12,
      13: 4,
      14: 22,
      15: 19,
      16: 8,
      17: 19,
      18: 13,
      19: 18,
      20: 19,
      21: 8,
      22: 11,
      23: 14,
      24: 17,
      25: 19,
      26: 12,
      27: 11,
      28: 16,
      29: 22,
      30: 19,
      31: 5
    }
  },
  {
    title: 'Scarhaven Keep',
    author: 'J.S. Fletcher',
    queryType: 'nearby',
    query: 'Richard Copplestone|Copplestone',
    question: 'Nearby Words',
    numChapters: 31,
    before: [
      ['this', 1],
      ['is', 1],
      ['Mr', 1]
    ],
    after: [
      ['had', 18],
      ['the', 20],
      ['the', 9]
    ]
  },
  {
    title: 'Scarhaven Keep',
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query:
      'Peter Chatfield|Addie Chatfield|Addie|Martin|Andrius|Martin Andrius',
    question: 'Perpetrator',
    numChapters: 31,
    results: {
      1: 1,
      2: 0,
      3: 0,
      4: 2,
      5: 1,
      6: 15,
      7: 0,
      8: 5,
      9: 2,
      10: 1,
      11: 0,
      12: 1,
      13: 0,
      14: 1,
      15: 0,
      16: 3,
      17: 9,
      18: 2,
      19: 4,
      20: 22,
      21: 6,
      22: 3,
      23: 2,
      24: 2,
      25: 2,
      26: 1,
      27: 2,
      28: 0,
      29: 8,
      30: 10,
      31: 41
    }
  },
  {
    title: 'Scarhaven Keep',
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: 'murder|fraud',
    question: 'Crime',
    numChapters: 31,
    results: {
      1: 0,
      2: 0,
      3: 0,
      4: 1,
      5: 0,
      6: 0,
      7: 0,
      8: 0,
      9: 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 1,
      16: 2,
      17: 0,
      18: 2,
      19: 0,
      20: 1,
      21: 0,
      22: 0,
      23: 3,
      24: 0,
      25: 1,
      26: 0,
      27: 0,
      28: 0,
      29: 0,
      30: 3,
      31: 0
    }
  },
  {
    title: 'Scarhaven Keep',
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: 'Audrey Greyle',
    question: 'Other Suspects',
    numChapters: 31,
    results: {
      1: 0,
      2: 0,
      3: 1,
      4: 2,
      5: 0,
      6: 0,
      7: 2,
      8: 0,
      9: 1,
      10: 0,
      11: 0,
      12: 0,
      13: 1,
      14: 0,
      15: 1,
      16: 0,
      17: 0,
      18: 2,
      19: 2,
      20: 0,
      21: 0,
      22: 0,
      23: 0,
      24: 0,
      25: 0,
      26: 0,
      27: 0,
      28: 0,
      29: 0,
      30: 0,
      31: 1
    }
  },
  {
    title: 'The Talleyrand Maxim',
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: 'Linford Pratt|Pratt',
    question: 'Detective',
    numChapters: 28,
    results: {
      1: 28,
      2: 33,
      3: 16,
      4: 4,
      5: 38,
      6: 34,
      7: 36,
      8: 37,
      9: 6,
      10: 20,
      11: 7,
      12: 61,
      13: 34,
      14: 23,
      15: 21,
      16: 30,
      17: 21,
      18: 23,
      19: 1,
      20: 17,
      21: 48,
      22: 33,
      23: 25,
      24: 21,
      25: 28,
      26: 17,
      27: 16,
      28: 14
    }
  },
  {
    title: 'The Talleyrand Maxim',
    author: 'J.S. Fletcher',
    queryType: 'nearby',
    query: 'Linford Pratt|Pratt',
    question: 'Nearby Words',
    numChapters: 28,
    before: [
      ['Barford', 2],
      ['to', 2],
      ['to', 3]
    ],
    after: [
      ['had', 37],
      ['to', 21],
      ['a', 14]
    ]
  },
  {
    title: 'The Talleyrand Maxim',
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: 'Harper Mallathorpe|Harper|Mallathorpe',
    question: 'Perpetrator',
    numChapters: 28,
    results: {
      1: 16,
      2: 18,
      3: 9,
      4: 38,
      5: 46,
      6: 4,
      7: 5,
      8: 28,
      9: 10,
      10: 18,
      11: 13,
      12: 47,
      13: 35,
      14: 24,
      15: 9,
      16: 16,
      17: 6,
      18: 2,
      19: 21,
      20: 0,
      21: 12,
      22: 3,
      23: 0,
      24: 0,
      25: 14,
      26: 2,
      27: 20,
      28: 37
    }
  },
  {
    title: 'The Talleyrand Maxim',
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: 'murder',
    question: 'Crime',
    numChapters: 28,
    results: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 2,
      8: 1,
      9: 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 3,
      16: 0,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 4,
      22: 0,
      23: 1,
      24: 0,
      25: 0,
      26: 2,
      27: 0,
      28: 2
    }
  },
  {
    title: 'The Talleyrand Maxim',
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: 'Nesta',
    question: 'Other Suspects',
    numChapters: 28,
    results: {
      1: 0,
      2: 2,
      3: 0,
      4: 11,
      5: 1,
      6: 0,
      7: 1,
      8: 1,
      9: 10,
      10: 5,
      11: 5,
      12: 21,
      13: 5,
      14: 21,
      15: 16,
      16: 15,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 5,
      22: 6,
      23: 0,
      24: 0,
      25: 2,
      26: 1,
      27: 2,
      28: 28
    }
  },
  {
    title: 'The Middle Temple Murder',
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: 'Frank Spargo|Frank|Spargo',
    question: 'Detective',
    numChapters: 36,
    results: {
      1: 29,
      2: 31,
      3: 40,
      4: 6,
      5: 32,
      6: 34,
      7: 37,
      8: 23,
      9: 33,
      10: 27,
      11: 14,
      12: 6,
      13: 3,
      14: 41,
      15: 35,
      16: 26,
      17: 28,
      18: 2,
      19: 23,
      20: 25,
      21: 29,
      22: 37,
      23: 31,
      24: 29,
      25: 18,
      26: 30,
      27: 32,
      28: 39,
      29: 31,
      30: 36,
      31: 26,
      32: 27,
      33: 31,
      34: 35,
      35: 19,
      36: 21
    }
  },
  {
    title: 'The Middle Temple Murder',
    author: 'J.S. Fletcher',
    queryType: 'nearby',
    query: 'Frank Spargo|Frank|Spargo',
    question: 'Nearby Words',
    numChapters: 36,
    before: [
      ['This', 1],
      ['is', 1],
      ['Mr', 2]
    ],
    after: [
      ['had', 25],
      ['the', 34],
      ['the', 32]
    ]
  },
  {
    title: 'The Middle Temple Murder',
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: 'Jane Baylis|Miss Baylis',
    question: 'Perpetrator',
    numChapters: 36,
    results: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 0,
      8: 0,
      9: 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 0,
      16: 0,
      17: 0,
      18: 0,
      19: 4,
      20: 0,
      21: 4,
      22: 0,
      23: 13,
      24: 10,
      25: 5,
      26: 6,
      27: 11,
      28: 2,
      29: 1,
      30: 1,
      31: 0,
      32: 0,
      33: 0,
      34: 0,
      35: 0,
      36: 5
    }
  },
  {
    title: 'The Middle Temple Murder',
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: 'murder',
    question: 'Crime',
    numChapters: 36,
    results: {
      1: 5,
      2: 2,
      3: 4,
      4: 1,
      5: 8,
      6: 7,
      7: 1,
      8: 8,
      9: 5,
      10: 0,
      11: 2,
      12: 1,
      13: 1,
      14: 3,
      15: 0,
      16: 0,
      17: 0,
      18: 0,
      19: 0,
      20: 4,
      21: 3,
      22: 3,
      23: 2,
      24: 2,
      25: 3,
      26: 2,
      27: 3,
      28: 2,
      29: 2,
      30: 7,
      31: 1,
      32: 0,
      33: 0,
      34: 2,
      35: 4,
      36: 6
    }
  },
  {
    title: 'The Middle Temple Murder',
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: 'Stephen Aylmore|Chamberlayne|Myerst',
    question: 'Other Suspects',
    numChapters: 36,
    results: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 1,
      7: 2,
      8: 8,
      9: 9,
      10: 12,
      11: 1,
      12: 0,
      13: 0,
      14: 1,
      15: 0,
      16: 0,
      17: 0,
      18: 9,
      19: 25,
      20: 14,
      21: 1,
      22: 0,
      23: 0,
      24: 0,
      25: 0,
      26: 0,
      27: 0,
      28: 0,
      29: 2,
      30: 2,
      31: 2,
      32: 12,
      33: 0,
      34: 30,
      35: 31,
      36: 20
    }
  },
  {
    title: "Dead Men's Money",
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: 'Hugh Moneylaw|Hugh|Moneylaw',
    question: 'Detective',
    numChapters: 37,
    results: {
      1: 4,
      2: 4,
      3: 0,
      4: 7,
      5: 6,
      6: 1,
      7: 0,
      8: 5,
      9: 6,
      10: 2,
      11: 4,
      12: 1,
      13: 5,
      14: 3,
      15: 6,
      16: 1,
      17: 3,
      18: 3,
      19: 0,
      20: 0,
      21: 4,
      22: 8,
      23: 1,
      24: 1,
      25: 10,
      26: 4,
      27: 1,
      28: 1,
      29: 2,
      30: 3,
      31: 6,
      32: 5,
      33: 1,
      34: 12,
      35: 7,
      36: 5,
      37: 1
    }
  },
  {
    title: "Dead Men's Money",
    author: 'J.S. Fletcher',
    queryType: 'nearby',
    query: 'Hugh Moneylaw|Hugh|Moneylaw',
    question: 'Nearby Words',
    numChapters: 37,
    before: [
      ['what', 1],
      ['the', 1],
      ['witness', 1]
    ],
    after: [
      ['', 0],
      ['', 0],
      ['', 0]
    ]
  },
  {
    title: "Dead Men's Money",
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: 'Gilbert Carstairs|Meekin',
    question: 'Perpetrator',
    numChapters: 37,
    results: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 3,
      8: 1,
      9: 1,
      10: 2,
      11: 2,
      12: 2,
      13: 4,
      14: 2,
      15: 2,
      16: 0,
      17: 2,
      18: 2,
      19: 2,
      20: 2,
      21: 3,
      22: 5,
      23: 0,
      24: 6,
      25: 5,
      26: 5,
      27: 7,
      28: 2,
      29: 7,
      30: 2,
      31: 0,
      32: 1,
      33: 2,
      34: 0,
      35: 0,
      36: 0,
      37: 25
    }
  },
  {
    title: "Dead Men's Money",
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: 'murder',
    question: 'Crime',
    numChapters: 37,
    results: {
      1: 1,
      2: 0,
      3: 1,
      4: 9,
      5: 7,
      6: 10,
      7: 4,
      8: 3,
      9: 3,
      10: 3,
      11: 4,
      12: 1,
      13: 0,
      14: 6,
      15: 3,
      16: 4,
      17: 6,
      18: 5,
      19: 2,
      20: 1,
      21: 3,
      22: 3,
      23: 1,
      24: 0,
      25: 3,
      26: 1,
      27: 2,
      28: 0,
      29: 0,
      30: 2,
      31: 1,
      32: 0,
      33: 1,
      34: 0,
      35: 5,
      36: 1,
      37: 8
    }
  },
  {
    title: "Dead Men's Money",
    author: 'J.S. Fletcher',
    queryType: 'occurrences',
    query: '',
    question: 'Other Suspects',
    numChapters: 37,
    results: {
      1: 106,
      2: 144,
      3: 56,
      4: 82,
      5: 100,
      6: 86,
      7: 77,
      8: 107,
      9: 111,
      10: 131,
      11: 102,
      12: 109,
      13: 100,
      14: 99,
      15: 113,
      16: 122,
      17: 105,
      18: 98,
      19: 57,
      20: 101,
      21: 129,
      22: 84,
      23: 117,
      24: 103,
      25: 104,
      26: 112,
      27: 116,
      28: 99,
      29: 96,
      30: 107,
      31: 119,
      32: 93,
      33: 83,
      34: 115,
      35: 110,
      36: 98,
      37: 196
    }
  },
  {
    title: 'The Mysterious Affair at Styles',
    author: 'Agatha Christie',
    queryType: 'occurrences',
    query: 'Hercule|Poirot',
    question: 'Detective',
    numChapters: 13,
    results: {
      1: 1,
      2: 7,
      3: 2,
      4: 46,
      5: 89,
      6: 13,
      7: 61,
      8: 59,
      9: 24,
      10: 53,
      11: 25,
      12: 15,
      13: 26
    }
  },
  {
    title: 'The Mysterious Affair at Styles',
    author: 'Agatha Christie',
    queryType: 'occurrences',
    query: 'Alfred|Evelyn|Howard',
    question: 'Perpetrator',
    numChapters: 13,
    results: {
      1: 30,
      2: 5,
      3: 4,
      4: 4,
      5: 27,
      6: 16,
      7: 13,
      8: 38,
      9: 7,
      10: 2,
      11: 12,
      12: 6,
      13: 26
    }
  },
  {
    title: 'The Mysterious Affair at Styles',
    author: 'Agatha Christie',
    queryType: 'occurrences',
    query: 'strych|poison',
    question: 'Crime',
    numChapters: 13,
    results: {
      1: 5,
      2: 3,
      3: 3,
      4: 11,
      5: 5,
      6: 25,
      7: 11,
      8: 11,
      9: 8,
      10: 10,
      11: 11,
      12: 17,
      13: 7
    }
  },
  {
    title: 'The Mysterious Affair at Styles',
    author: 'Agatha Christie',
    queryType: 'occurrences',
    query: 'John|[^St. ]Mary|Lawrence|Cynthia|Murdoch',
    question: 'Other Suspects',
    numChapters: 13,
    results: {
      1: 45,
      2: 45,
      3: 30,
      4: 10,
      5: 61,
      6: 7,
      7: 11,
      8: 20,
      9: 55,
      10: 31,
      11: 37,
      12: 21,
      13: 41
    }
  },
  {
    title: 'The Secret Adversary',
    author: 'Agatha Christie',
    queryType: 'occurrences',
    query: 'Tommy|Beresford|Prudence|Tuppence|Cowley',
    question: 'Detective',
    numChapters: 28,
    results: {
      1: 79,
      2: 50,
      3: 56,
      4: 44,
      5: 35,
      6: 63,
      7: 34,
      8: 30,
      9: 49,
      10: 31,
      11: 38,
      12: 101,
      13: 52,
      14: 3,
      15: 48,
      16: 62,
      17: 84,
      18: 92,
      19: 39,
      20: 30,
      21: 38,
      22: 12,
      23: 44,
      24: 18,
      25: 42,
      26: 28,
      27: 43,
      28: 29
    }
  },
  {
    title: 'The Secret Adversary',
    author: 'Agatha Christie',
    queryType: 'occurrences',
    query: 'disapp|docu',
    question: 'Crime',
    numChapters: 28,
    results: {
      1: 0,
      2: 0,
      3: 0,
      4: 6,
      5: 1,
      6: 0,
      7: 0,
      8: 4,
      9: 2,
      10: 0,
      11: 1,
      12: 0,
      13: 1,
      14: 0,
      15: 0,
      16: 0,
      17: 3,
      18: 1,
      19: 1,
      20: 0,
      21: 0,
      22: 1,
      23: 2,
      24: 1,
      25: 0,
      26: 1,
      27: 2,
      28: 0
    }
  },
  {
    title: 'The Secret Adversary',
    author: 'Agatha Christie',
    queryType: 'occurrences',
    query:
      'Edgerton|Mr. Brown|Marguerite|Rita|Vandemeyer|Whittington|Boris|Ivanovitch|Stepanov',
    question: 'Perpetrator',
    numChapters: 28,
    results: {
      1: 0,
      2: 40,
      3: 4,
      4: 9,
      5: 2,
      6: 16,
      7: 35,
      8: 10,
      9: 12,
      10: 55,
      11: 18,
      12: 65,
      13: 28,
      14: 14,
      15: 3,
      16: 10,
      17: 10,
      18: 6,
      19: 12,
      20: 6,
      21: 6,
      22: 6,
      23: 3,
      24: 10,
      25: 28,
      26: 14,
      27: 10,
      28: 0
    }
  },
  {
    title: 'The Secret Adversary',
    author: 'Agatha Christie',
    queryType: 'occurrences',
    query: 'Julius|Hersheimer|Carter',
    question: 'Other Suspects',
    numChapters: 28,
    results: {
      1: 0,
      2: 0,
      3: 0,
      4: 22,
      5: 9,
      6: 2,
      7: 6,
      8: 0,
      9: 8,
      10: 0,
      11: 27,
      12: 24,
      13: 33,
      14: 15,
      15: 18,
      16: 0,
      17: 12,
      18: 45,
      19: 24,
      20: 24,
      21: 23,
      22: 11,
      23: 2,
      24: 45,
      25: 5,
      26: 9,
      27: 37,
      28: 10
    }
  },
  {
    title: 'The Murder on the Links',
    author: 'Agatha Christie',
    queryType: 'occurrences',
    query: 'Hercule|Poirot',
    question: 'Detective',
    numChapters: 28,
    results: {
      1: 3,
      2: 38,
      3: 15,
      4: 26,
      5: 12,
      6: 26,
      7: 36,
      8: 6,
      9: 18,
      10: 6,
      11: 10,
      12: 21,
      13: 17,
      14: 1,
      15: 29,
      16: 0,
      17: 28,
      18: 28,
      19: 23,
      20: 23,
      21: 17,
      22: 23,
      23: 14,
      24: 33,
      25: 1,
      26: 6,
      27: 51,
      28: 22
    }
  },
  {
    title: 'The Murder on the Links',
    author: 'Agatha Christie',
    queryType: 'occurrences',
    query: 'Marthe|Daubreuil',
    question: 'Perpetrator',
    numChapters: 28,
    results: {
      1: 0,
      2: 0,
      3: 14,
      4: 2,
      5: 1,
      6: 0,
      7: 18,
      8: 0,
      9: 1,
      10: 7,
      11: 10,
      12: 0,
      13: 7,
      14: 2,
      15: 5,
      16: 0,
      17: 9,
      18: 10,
      19: 1,
      20: 16,
      21: 3,
      22: 4,
      23: 0,
      24: 4,
      25: 0,
      26: 0,
      27: 21,
      28: 50
    }
  },
  {
    title: 'The Murder on the Links',
    author: 'Agatha Christie',
    queryType: 'occurrences',
    query: 'stab|dea',
    question: 'Crime',
    numChapters: 28,
    results: {
      1: 2,
      2: 1,
      3: 10,
      4: 10,
      5: 8,
      6: 7,
      7: 10,
      8: 7,
      9: 3,
      10: 6,
      11: 15,
      12: 13,
      13: 6,
      14: 12,
      15: 15,
      16: 3,
      17: 7,
      18: 4,
      19: 11,
      20: 11,
      21: 11,
      22: 6,
      23: 3,
      24: 2,
      25: 1,
      26: 1,
      27: 6,
      28: 14
    }
  },
  {
    title: 'The Murder on the Links',
    author: 'Agatha Christie',
    queryType: 'occurrences',
    query: 'Eloise|Madame Renauld|Jack|Daubreuil|Bella|Duveen',
    question: 'Other Suspects',
    numChapters: 28,
    results: {
      1: 0,
      2: 0,
      3: 23,
      4: 12,
      5: 7,
      6: 0,
      7: 15,
      8: 2,
      9: 5,
      10: 18,
      11: 22,
      12: 4,
      13: 8,
      14: 4,
      15: 5,
      16: 0,
      17: 18,
      18: 14,
      19: 16,
      20: 40,
      21: 26,
      22: 20,
      23: 16,
      24: 15,
      25: 19,
      26: 20,
      27: 34,
      28: 71
    }
  },
  {
    title: 'The Man in the Brown Suit',
    author: 'Agatha Christie',
    queryType: 'occurrences',
    query: 'Anne|Beddingfeld',
    question: 'Detective',
    numChapters: 36,
    results: {
      1: 7,
      2: 1,
      3: 0,
      4: 4,
      5: 1,
      6: 0,
      7: 0,
      8: 0,
      9: 5,
      10: 0,
      11: 6,
      12: 10,
      13: 12,
      14: 10,
      15: 8,
      16: 10,
      17: 3,
      18: 9,
      19: 0,
      20: 12,
      21: 1,
      22: 23,
      23: 1,
      24: 11,
      25: 9,
      26: 2,
      27: 11,
      28: 11,
      29: 8,
      30: 10,
      31: 1,
      32: 11,
      33: 12,
      34: 6,
      35: 8,
      36: 5
    }
  },
  {
    title: 'The Man in the Brown Suit',
    author: 'Agatha Christie',
    queryType: 'occurrences',
    query: 'Eustace|Pedler',
    question: 'Perpetrator',
    numChapters: 36,
    results: {
      1: 2,
      2: 0,
      3: 4,
      4: 2,
      5: 0,
      6: 6,
      7: 2,
      8: 12,
      9: 13,
      10: 0,
      11: 14,
      12: 10,
      13: 3,
      14: 4,
      15: 6,
      16: 11,
      17: 14,
      18: 3,
      19: 2,
      20: 26,
      21: 9,
      22: 6,
      23: 7,
      24: 11,
      25: 1,
      26: 9,
      27: 5,
      28: 4,
      29: 5,
      30: 10,
      31: 18,
      32: 23,
      33: 27,
      34: 5,
      35: 1,
      36: 6
    }
  },
  {
    title: 'The Man in the Brown Suit',
    author: 'Agatha Christie',
    queryType: 'occurrences',
    query: 'tube|kill',
    question: 'Crime',
    numChapters: 36,
    results: {
      1: 0,
      2: 0,
      3: 1,
      4: 2,
      5: 0,
      6: 0,
      7: 1,
      8: 0,
      9: 1,
      10: 2,
      11: 0,
      12: 0,
      13: 1,
      14: 0,
      15: 6,
      16: 5,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 0,
      22: 1,
      23: 1,
      24: 0,
      25: 1,
      26: 3,
      27: 0,
      28: 0,
      29: 0,
      30: 0,
      31: 0,
      32: 5,
      33: 2,
      34: 2,
      35: 2,
      36: 0
    }
  },
  {
    title: 'The Man in the Brown Suit',
    author: 'Agatha Christie',
    queryType: 'occurrences',
    query: 'Harry|Rayburn|John|Eardsley|Race|Suzanne|Blair',
    question: 'Other Suspects',
    numChapters: 36,
    results: {
      1: 0,
      2: 0,
      3: 1,
      4: 0,
      5: 0,
      6: 2,
      7: 0,
      8: 2,
      9: 15,
      10: 0,
      11: 23,
      12: 10,
      13: 33,
      14: 26,
      15: 24,
      16: 20,
      17: 21,
      18: 13,
      19: 4,
      20: 46,
      21: 18,
      22: 23,
      23: 21,
      24: 36,
      25: 22,
      26: 11,
      27: 33,
      28: 18,
      29: 9,
      30: 17,
      31: 6,
      32: 19,
      33: 32,
      34: 19,
      35: 20,
      36: 15
    }
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'Sherlock Holmes',
    queryType: 'occurrences',
    question: 'Detective',
    results: {
      1: 19,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      2: 23,
      3: 0,
      4: 32,
      5: 10,
      6: 20,
      7: 36,
      8: 0,
      9: 0
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'Watson',
    queryType: 'occurrences',
    question: 'Detective',
    results: {
      1: 23,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      2: 0,
      3: 0,
      4: 2,
      5: 0,
      6: 25,
      7: 4,
      8: 0,
      9: 0
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'Alec MacDonald|inspector|Inspector|Mr. Mac|Mac',
    queryType: 'occurrences',
    question: 'Detective',
    results: {
      1: 9,
      10: 1,
      11: 1,
      12: 0,
      13: 1,
      14: 1,
      2: 25,
      3: 0,
      4: 15,
      5: 15,
      6: 14,
      7: 31,
      8: 0,
      9: 0
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'White Mason|police officer',
    queryType: 'occurrences',
    question: 'Detective',
    results: {
      1: 0,
      10: 2,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      2: 2,
      3: 2,
      4: 15,
      5: 2,
      6: 3,
      7: 6,
      8: 1,
      9: 0
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'P. Moriarty|Professor Moriarty|professor',
    queryType: 'occurrences',
    question: 'Perpetrator',
    results: {
      1: 4,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      2: 8,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 0,
      8: 0,
      9: 0
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'Ted Baldwin|Teddy Baldwin|Mr. Baldwin',
    queryType: 'occurrences',
    question: 'Perpetrator',
    results: {
      1: 0,
      10: 11,
      11: 1,
      12: 4,
      13: 5,
      14: 5,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 2,
      8: 0,
      9: 27
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'Mrs. Douglas',
    queryType: 'occurrences',
    question: 'Other Suspects',
    results: {
      1: 5,
      10: 0,
      11: 0,
      12: 1,
      13: 0,
      14: 2,
      2: 3,
      3: 23,
      4: 16,
      5: 31,
      6: 18,
      7: 19,
      8: 0,
      9: 0
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'Cecil James Barker',
    queryType: 'occurrences',
    question: 'Other Suspects',
    results: {
      1: 0,
      10: 2,
      11: 0,
      12: 1,
      13: 0,
      14: 1,
      2: 0,
      3: 20,
      4: 10,
      5: 27,
      6: 15,
      7: 23,
      8: 0,
      9: 2
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 7,
    query: 'Sherlock Holmes',
    queryType: 'occurrences',
    question: 'Detective',
    results: {
      1: 8,
      2: 10,
      3: 13,
      4: 10,
      5: 10,
      6: 16,
      7: 25
    },
    title: 'A Study in Scarlet'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 7,
    query: 'Watson',
    queryType: 'occurrences',
    question: 'Detective',
    results: {
      1: 2,
      2: 0,
      3: 0,
      4: 0,
      5: 2,
      6: 1,
      7: 0
    },
    title: 'A Study in Scarlet'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 7,
    query: 'Gregson',
    queryType: 'occurrences',
    question: 'Detective',
    results: {
      1: 0,
      2: 0,
      3: 16,
      4: 3,
      5: 0,
      6: 11,
      7: 7
    },
    title: 'A Study in Scarlet'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 7,
    query: 'Lestrade',
    queryType: 'occurrences',
    question: 'Detective',
    results: {
      1: 0,
      2: 2,
      3: 13,
      4: 4,
      5: 0,
      6: 7,
      7: 14
    },
    title: 'A Study in Scarlet'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 7,
    query: 'Jefferson Hope|cabman|cab driver|hansom',
    queryType: 'occurrences',
    question: 'Perpetrator',
    results: {
      1: 1,
      2: 0,
      3: 1,
      4: 1,
      5: 0,
      6: 0,
      7: 5
    },
    title: 'A Study in Scarlet'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 7,
    query: 'Enoch Drebber',
    queryType: 'occurrences',
    question: 'Other Suspects',
    results: {
      1: 0,
      2: 0,
      3: 5,
      4: 0,
      5: 3,
      6: 14,
      7: 7
    },
    title: 'A Study in Scarlet'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 7,
    query: 'Joseph Stangerson',
    queryType: 'occurrences',
    question: 'Other Suspects',
    results: {
      1: 0,
      2: 0,
      3: 5,
      4: 0,
      5: 0,
      6: 10,
      7: 11
    },
    title: 'A Study in Scarlet'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 7,
    query: 'M. Charpentier|Madame Charpentier|Madame|Mrs. Charpentier',
    queryType: 'occurrences',
    question: 'Other Suspects',
    results: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 6,
      7: 0
    },
    title: 'A Study in Scarlet'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 7,
    query: 'A. Charpentier|Arthur Charpentier|Arthur',
    queryType: 'occurrences',
    question: 'Other Suspects',
    results: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 4,
      7: 0
    },
    title: 'A Study in Scarlet'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 12,
    query: 'Sherlock Holmes',
    queryType: 'occurrences',
    question: 'Detective',
    results: {
      1: 4,
      10: 16,
      11: 8,
      12: 9,
      2: 9,
      3: 8,
      4: 5,
      5: 16,
      6: 14,
      7: 14,
      8: 16,
      9: 16
    },
    title: 'The Sign of the Four'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 12,
    query: 'Watson',
    queryType: 'occurrences',
    question: 'Detective',
    results: {
      1: 1,
      10: 2,
      11: 2,
      12: 0,
      2: 1,
      3: 0,
      4: 1,
      5: 2,
      6: 4,
      7: 3,
      8: 5,
      9: 3
    },
    title: 'The Sign of the Four'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 12,
    query: 'Jonathan Small',
    queryType: 'occurrences',
    question: 'Perpetrator',
    results: {
      1: 0,
      10: 5,
      11: 3,
      12: 17,
      2: 0,
      3: 1,
      4: 0,
      5: 0,
      6: 1,
      7: 14,
      8: 3,
      9: 3
    },
    title: 'The Sign of the Four'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 12,
    query: 'Tonga',
    queryType: 'occurrences',
    question: 'Perpetrator',
    results: {
      1: 0,
      10: 0,
      11: 2,
      12: 11,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 0,
      8: 0,
      9: 0
    },
    title: 'The Sign of the Four'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 12,
    query: 'Major Sholto|Major|major',
    queryType: 'occurrences',
    question: 'Other Suspects',
    results: {
      1: 0,
      10: 0,
      11: 2,
      12: 11,
      2: 2,
      3: 5,
      4: 1,
      5: 0,
      6: 0,
      7: 5,
      8: 0,
      9: 0
    },
    title: 'The Sign of the Four'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 12,
    query: 'Thaddeus|Thaddeus Sholto',
    queryType: 'occurrences',
    question: 'Other Suspects',
    results: {
      1: 0,
      10: 0,
      11: 1,
      12: 1,
      2: 0,
      3: 0,
      4: 5,
      5: 14,
      6: 8,
      7: 2,
      8: 2,
      9: 3
    },
    title: 'The Sign of the Four'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 15,
    query: 'Sherlock Holmes',
    queryType: 'occurrences',
    question: 'Detective',
    results: {
      1: 20,
      10: 5,
      11: 1,
      12: 26,
      13: 17,
      14: 25,
      15: 2,
      2: 10,
      3: 13,
      4: 27,
      5: 27,
      6: 4,
      7: 6,
      8: 1,
      9: 7
    },
    title: 'The Hound of the Baskervilles'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 15,
    query: 'Watson',
    queryType: 'occurrences',
    question: 'Detective',
    results: {
      1: 10,
      10: 4,
      11: 7,
      12: 13,
      13: 15,
      14: 4,
      15: 2,
      2: 1,
      3: 6,
      4: 15,
      5: 7,
      6: 3,
      7: 10,
      8: 0,
      9: 14
    },
    title: 'The Hound of the Baskervilles'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 15,
    query: 'Lestrade',
    queryType: 'occurrences',
    question: 'Detective',
    results: {
      1: 0,
      10: 0,
      11: 0,
      12: 0,
      13: 3,
      14: 7,
      15: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 0,
      8: 0,
      9: 0
    },
    title: 'The Hound of the Baskervilles'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 15,
    query: 'Mr. Stapleton|Jack|Stapleton|naturalist',
    queryType: 'occurrences',
    question: 'Perpetrator',
    results: {
      1: 1,
      10: 4,
      11: 4,
      12: 13,
      13: 10,
      14: 9,
      15: 31,
      2: 3,
      3: 2,
      4: 0,
      5: 0,
      6: 2,
      7: 18,
      8: 8,
      9: 12
    },
    title: 'The Hound of the Baskervilles'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 15,
    query: 'Barrymore|butler',
    queryType: 'occurrences',
    question: 'Other Suspects',
    results: {
      1: 0,
      10: 17,
      11: 3,
      12: 2,
      13: 2,
      14: 0,
      15: 1,
      2: 10,
      3: 0,
      4: 0,
      5: 9,
      6: 4,
      7: 12,
      8: 10,
      9: 22
    },
    title: 'The Hound of the Baskervilles'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 15,
    query: 'Laura Lyons',
    queryType: 'occurrences',
    question: 'Other Suspects',
    results: {
      1: 0,
      10: 3,
      11: 7,
      12: 3,
      13: 6,
      14: 0,
      15: 4,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 0,
      8: 0,
      9: 0
    },
    title: 'The Hound of the Baskervilles'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 1,
    query: 'Sherlock Holmes',
    queryType: 'occurrences',
    question: 'Detective',
    results: {
      1: 48
    },
    title: 'The Boscombe Valley Mystery'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 1,
    query: 'Watson',
    queryType: 'occurrences',
    question: 'Detective',
    results: {
      1: 4
    },
    title: 'The Boscombe Valley Mystery'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 1,
    query: 'Lestrade',
    queryType: 'occurrences',
    question: 'Detective',
    results: {
      1: 24
    },
    title: 'The Boscombe Valley Mystery'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 1,
    query: 'John Turner|Mr. Turner|Turner',
    queryType: 'occurrences',
    question: 'Perpetrator',
    results: {
      1: 21
    },
    title: 'The Boscombe Valley Mystery'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 1,
    query: 'James McCarthy',
    queryType: 'occurrences',
    question: 'Other Suspects',
    results: {
      1: 45
    },
    title: 'The Boscombe Valley Mystery'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'dead',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 1,
      11: 0,
      12: 2,
      13: 4,
      14: 0,
      2: 4,
      3: 4,
      4: 2,
      5: 5,
      6: 5,
      7: 4,
      8: 2,
      9: 4
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'death',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 2,
      11: 1,
      12: 3,
      13: 0,
      14: 0,
      2: 2,
      3: 0,
      4: 0,
      5: 0,
      6: 2,
      7: 3,
      8: 0,
      9: 1
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'murder',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 1,
      10: 3,
      11: 7,
      12: 6,
      13: 5,
      14: 3,
      2: 4,
      3: 5,
      4: 6,
      5: 2,
      6: 14,
      7: 3,
      8: 3,
      9: 4
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'crime',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 1,
      10: 2,
      11: 6,
      12: 2,
      13: 0,
      14: 3,
      2: 6,
      3: 4,
      4: 2,
      5: 2,
      6: 3,
      7: 2,
      8: 0,
      9: 3
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'blood',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 2,
      11: 3,
      12: 7,
      13: 1,
      14: 4,
      2: 0,
      3: 1,
      4: 5,
      5: 4,
      6: 3,
      7: 0,
      8: 0,
      9: 3
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'treasure',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 5,
      11: 0,
      12: 0,
      13: 1,
      14: 1,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 0,
      8: 0,
      9: 0
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'guilty',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 1,
      10: 0,
      11: 0,
      12: 1,
      13: 1,
      14: 0,
      2: 0,
      3: 0,
      4: 1,
      5: 0,
      6: 5,
      7: 0,
      8: 0,
      9: 0
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'assassin',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 1,
      11: 0,
      12: 2,
      13: 1,
      14: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 1,
      6: 4,
      7: 0,
      8: 0,
      9: 0
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'pain',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 3,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      2: 2,
      3: 0,
      4: 1,
      5: 0,
      6: 0,
      7: 0,
      8: 0,
      9: 0
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'victim',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 2,
      11: 0,
      12: 1,
      13: 0,
      14: 0,
      2: 0,
      3: 1,
      4: 0,
      5: 0,
      6: 1,
      7: 0,
      8: 0,
      9: 0
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'criminal',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 2,
      10: 4,
      11: 3,
      12: 3,
      13: 0,
      14: 0,
      2: 3,
      3: 0,
      4: 1,
      5: 1,
      6: 1,
      7: 1,
      8: 0,
      9: 0
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'attack',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 0,
      11: 1,
      12: 1,
      13: 0,
      14: 0,
      2: 0,
      3: 0,
      4: 3,
      5: 0,
      6: 0,
      7: 0,
      8: 0,
      9: 0
    },
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 7,
    query: 'dead',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      2: 0,
      3: 2,
      4: 1,
      5: 0,
      6: 1,
      7: 3
    },
    title: 'A Study in Scarlet'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 7,
    query: 'death',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 1,
      2: 0,
      3: 5,
      4: 0,
      5: 1,
      6: 4,
      7: 4
    },
    title: 'A Study in Scarlet'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 7,
    query: 'murder',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 1,
      2: 0,
      3: 7,
      4: 3,
      5: 2,
      6: 3,
      7: 8
    },
    title: 'A Study in Scarlet'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 7,
    query: 'crime',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 3,
      2: 4,
      3: 0,
      4: 0,
      5: 0,
      6: 3,
      7: 4
    },
    title: 'A Study in Scarlet'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 7,
    query: 'blood',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 9,
      2: 0,
      3: 6,
      4: 3,
      5: 1,
      6: 1,
      7: 4
    },
    title: 'A Study in Scarlet'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 7,
    query: 'victim',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      2: 0,
      3: 1,
      4: 0,
      5: 2,
      6: 2,
      7: 1
    },
    title: 'A Study in Scarlet'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 7,
    query: 'poison',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 1,
      2: 1,
      3: 1,
      4: 1,
      5: 2,
      6: 0,
      7: 1
    },
    title: 'A Study in Scarlet'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 7,
    query: 'wound',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 1,
      2: 1,
      3: 2,
      4: 0,
      5: 2,
      6: 0,
      7: 0
    },
    title: 'A Study in Scarlet'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 12,
    query: 'dead',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 1,
      10: 0,
      11: 1,
      12: 3,
      2: 1,
      3: 1,
      4: 4,
      5: 3,
      6: 2,
      7: 2,
      8: 1,
      9: 0
    },
    title: 'The Sign of the Four'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 12,
    query: 'death',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 1,
      11: 0,
      12: 8,
      2: 0,
      3: 2,
      4: 3,
      5: 1,
      6: 2,
      7: 3,
      8: 1,
      9: 1
    },
    title: 'The Sign of the Four'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 12,
    query: 'murder',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 1,
      10: 1,
      11: 1,
      12: 5,
      2: 0,
      3: 0,
      4: 1,
      5: 1,
      6: 1,
      7: 3,
      8: 1,
      9: 0
    },
    title: 'The Sign of the Four'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 12,
    query: 'crime',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 1,
      10: 0,
      11: 0,
      12: 1,
      2: 0,
      3: 0,
      4: 1,
      5: 0,
      6: 1,
      7: 3,
      8: 1,
      9: 0
    },
    title: 'The Sign of the Four'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 12,
    query: 'blood',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 0,
      11: 1,
      12: 7,
      2: 0,
      3: 0,
      4: 0,
      5: 3,
      6: 2,
      7: 1,
      8: 0,
      9: 0
    },
    title: 'The Sign of the Four'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 12,
    query: 'treasure',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 3,
      11: 9,
      12: 27,
      2: 0,
      3: 0,
      4: 12,
      5: 3,
      6: 2,
      7: 13,
      8: 2,
      9: 4
    },
    title: 'The Sign of the Four'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 12,
    query: 'suffer',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 0,
      11: 0,
      12: 0,
      2: 0,
      3: 1,
      4: 3,
      5: 0,
      6: 0,
      7: 0,
      8: 0,
      9: 1
    },
    title: 'The Sign of the Four'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 12,
    query: 'pain',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 1,
      10: 0,
      11: 0,
      12: 1,
      2: 0,
      3: 0,
      4: 2,
      5: 0,
      6: 0,
      7: 0,
      8: 1,
      9: 1
    },
    title: 'The Sign of the Four'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 12,
    query: 'poison',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 0,
      11: 1,
      12: 1,
      2: 1,
      3: 0,
      4: 0,
      5: 1,
      6: 3,
      7: 1,
      8: 2,
      9: 0
    },
    title: 'The Sign of the Four'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 12,
    query: 'criminal',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 2,
      10: 0,
      11: 0,
      12: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 1,
      7: 1,
      8: 2,
      9: 1
    },
    title: 'The Sign of the Four'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 15,
    query: 'dead',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 0,
      11: 1,
      12: 1,
      13: 3,
      14: 5,
      15: 3,
      2: 1,
      3: 2,
      4: 0,
      5: 1,
      6: 1,
      7: 0,
      8: 0,
      9: 0
    },
    title: 'The Hound of the Baskervilles'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 15,
    query: 'death',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 5,
      11: 6,
      12: 5,
      13: 8,
      14: 4,
      15: 11,
      2: 10,
      3: 4,
      4: 1,
      5: 2,
      6: 5,
      7: 5,
      8: 0,
      9: 0
    },
    title: 'The Hound of the Baskervilles'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 15,
    query: 'murder',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 0,
      11: 0,
      12: 4,
      13: 2,
      14: 1,
      15: 5,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 1,
      7: 0,
      8: 0,
      9: 0
    },
    title: 'The Hound of the Baskervilles'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 15,
    query: 'crime',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 1,
      10: 2,
      11: 0,
      12: 0,
      13: 1,
      14: 0,
      15: 2,
      2: 0,
      3: 2,
      4: 1,
      5: 0,
      6: 1,
      7: 0,
      8: 1,
      9: 2
    },
    title: 'The Hound of the Baskervilles'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 15,
    query: 'blood',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 0,
      11: 0,
      12: 2,
      13: 0,
      14: 1,
      15: 2,
      2: 1,
      3: 1,
      4: 0,
      5: 0,
      6: 2,
      7: 1,
      8: 0,
      9: 3
    },
    title: 'The Hound of the Baskervilles'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 15,
    query: 'suffer',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 1,
      11: 0,
      12: 0,
      13: 0,
      14: 1,
      15: 0,
      2: 1,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 0,
      8: 2,
      9: 0
    },
    title: 'The Hound of the Baskervilles'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 15,
    query: 'pain',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 0,
      11: 0,
      12: 2,
      13: 1,
      14: 1,
      15: 1,
      2: 0,
      3: 0,
      4: 1,
      5: 0,
      6: 1,
      7: 0,
      8: 1,
      9: 1
    },
    title: 'The Hound of the Baskervilles'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 15,
    query: 'steal',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 0,
      11: 2,
      12: 0,
      13: 0,
      14: 0,
      15: 0,
      2: 0,
      3: 0,
      4: 1,
      5: 0,
      6: 0,
      7: 0,
      8: 2,
      9: 4
    },
    title: 'The Hound of the Baskervilles'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 15,
    query: 'victim',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 0,
      11: 0,
      12: 1,
      13: 1,
      14: 2,
      15: 3,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 0,
      8: 0,
      9: 0
    },
    title: 'The Hound of the Baskervilles'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 15,
    query: 'criminal',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 0,
      11: 0,
      12: 2,
      13: 2,
      14: 0,
      15: 3,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 0,
      8: 1,
      9: 2
    },
    title: 'The Hound of the Baskervilles'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 15,
    query: 'wound',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 2,
      15: 1,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 1,
      7: 1,
      8: 0,
      9: 0
    },
    title: 'The Hound of the Baskervilles'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 1,
    query: 'dead',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 9
    },
    title: 'The Boscombe Valley Mystery'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 1,
    query: 'murder',
    queryType: 'occurrences',
    question: 'Crime',
    results: {
      1: 9
    },
    title: 'The Boscombe Valley Mystery'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'P. Moriarty|Professor Moriarty|professor',
    queryType: 'nearby',
    question: 'Nearby Words',
    before: [
      ['Holmes', 3],
      ['crime', 2],
      ['circles', 2]
    ],
    after: [
      ['criminal', 2],
      ['interest', 2],
      ['wild', 2]
    ],
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 14,
    query: 'Ted Baldwin|Teddy Baldwin|Mr. Baldwin',
    queryType: 'nearby',
    question: 'Nearby Words',
    before: [
      ['brother', 6],
      ['hand', 6],
      ['McMurdo', 4]
    ],
    after: [
      ['McMurdo', 5],
      ['McGinty', 3],
      ['cried', 3]
    ],
    title: 'The Valley of Fear'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 7,
    query: 'Jefferson Hope|cabman|cab driver|hansom',
    queryType: 'nearby',
    question: 'Nearby Words',
    before: [
      ['men', 2],
      ['Holmes', 1],
      ['engaged', 1]
    ],
    after: [
      ['help', 2],
      ['poison', 1],
      ['compel', 1]
    ],
    title: 'A Study in Scarlet'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 12,
    query: 'Jonathan Small',
    queryType: 'nearby',
    question: 'Nearby Words',
    before: [
      ['man', 4],
      ['matter', 4],
      ['lips', 3]
    ],
    after: [
      ['Jones', 4],
      ['man', 3],
      ['treasure', 3]
    ],
    title: 'The Sign of the Four'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 12,
    query: 'Tonga',
    queryType: 'nearby',
    question: 'Nearby Words',
    before: [
      ['little', 4],
      ['Sholto', 2],
      ['killed', 1]
    ],
    after: [
      ['darts', 3],
      ['managed', 2],
      ['rope', 2]
    ],
    title: 'The Sign of the Four'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 15,
    query: 'Mr. Stapleton|Jack|Stapleton|naturalist',
    queryType: 'nearby',
    question: 'Nearby Words',
    before: [
      ['Miss', 11],
      ['man', 5],
      ['Henry', 5]
    ],
    after: [
      ['Stapletons', 13],
      ['turned', 4],
      ['friend', 3]
    ],
    title: 'The Hound of the Baskervilles'
  },
  {
    author: 'Sir Arthur Conan Doyle',
    numChapters: 1,
    query: 'John Turner|Mr. Turner|Turner',
    queryType: 'nearby',
    question: 'Nearby Words',
    before: [
      ['son', 2],
      ['man', 2],
      ['know', 2]
    ],
    after: [
      ['daughter', 4],
      ['money', 2],
      ['ill', 2]
    ],
    title: 'The Boscombe Valley Mystery'
  }
]

export const searchableKeys = ['title', 'author', 'question']

export const barChartKeys = ['Nearby Words']

export const lineChartKeys = [
  'Crime',
  'Detective',
  'Perpetrator',
  'Other Suspects'
]
